module.exports = __webpack_public_path__ + "static/raleway-regular-0f3c55490c69ece3c06e43637e7aeb3d.woff2";